import React from "react";

import type { JSX } from "react";

export const MENU_ICON_SIZE = 1;

interface MenuProps {
  children: React.ReactNode;
}

export default function Menu({ children }: MenuProps): JSX.Element {
  return (
    <ul className="bg-card text-muted-foreground grow cursor-pointer text-[0.78125rem]">
      {children}
    </ul>
  );
}
